import { Component, OnDestroy } from '@angular/core';
import { SampleList } from './sample-list.model';
import { SampleListService } from './sample-list.service';
import { Router } from '@angular/router';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { JhiLanguageService } from '../../shared/core-utils';
import { AlertService } from '../../shared/alert/alert.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ParamContext } from '../../shared/service/param.context';
import { SubscriptionsManager } from '../../shared/util/subscriptions-manager';

@Component({
    selector: 'jhi-sample-search-list',
    templateUrl: './sample-search-list.component.html',
    styleUrls: ['./sample-search-list.component.css']
})
export class SampleSearchListComponent implements OnDestroy {

    searchString: string;
    exactMatch = false;
    sampleListResults: SampleList[] = [];
    selectedListId = 0;
    displayHelpPopup = false;
    predicate = 'id';
    reverse: boolean;

    subscriptionManager = new SubscriptionsManager();

    constructor(private sampleListService: SampleListService,
                private router: Router,
                private alertService: AlertService,
                private languageservice: JhiLanguageService,
                public activeModal: NgbActiveModal,
                private paramContext: ParamContext,
    ) {
    }

    ngOnDestroy(): void {
        this.subscriptionManager.unsubscribeAll();
    }

    searchList() {

        if (this.searchString.trim().length === 0) {
            this.sampleListResults = [];
            return;
        }

        const params = {
            searchString: this.searchString,
            exactMatch: this.exactMatch,
            programUUID : this.paramContext.programUUID,
            sort: this.sort()
        };
        this.subscriptionManager.add = this.sampleListService.search(params).subscribe(
            (res: HttpResponse<SampleList[]>) => {
                this.sampleListResults = res.body;
            });
    }

    selectList(selectedSampleList: SampleList) {
        this.selectedListId = selectedSampleList.id;
        this.router.navigate(['/sample-manager'], { queryParams: {
            listId: this.selectedListId
        }
        });
    }

    reset() {
        this.searchString = '';
        this.exactMatch = false;
        this.sampleListResults = [];
        this.selectedListId = 0;
        this.dismiss();
    }

    hideHelpPopup() {
        this.displayHelpPopup = false;
    }

    sort() {
        const result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
        if (this.predicate !== 'id') {
            result.push('id');
        }
        return result;
    }

    trackId(index: number, item: SampleList) {
        return item.id;
    }

    confirm() {
        this.activeModal.close('confirm');
    }

    dismiss() {
        this.activeModal.dismiss('cancel');
    }
}
